import { render, staticRenderFns } from "./OrderTagEdit.vue?vue&type=template&id=10c39128&"
import script from "./OrderTagEdit.vue?vue&type=script&lang=js&"
export * from "./OrderTagEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports